import React from "react";
import { InputBase } from "@material-ui/core";
import { Box } from "..";

const InputText = ({ Icon, ...props }) => {
  return (
    <Box
      alignItems="center"
      borderRadius={10}
      boxShadow={3}
      color="blue.main"
      display="flex"
      px={[1, 2]}
      py={1.5}
    >
      {Icon && <Icon />}
      <Box component={InputBase} ml={[1, 2]} flex={1} {...props} />
    </Box>
  );
};

export default InputText;
